// The one modal every screen uses. Behaviour is antd's Modal with the props
// you pass (nothing is defaulted, so each dialog keeps its own sizing and
// placement); what it adds is a stable class hook so each industry skin can
// style every dialog from its own SCSS, e.g.
//   :root[data-industry='coffee'] .app-modal--auth .ant-modal-content { … }
//
// kinds in use: auth, account, account-select, address, brand-select,
//   cancel-order, checkout, filters, order-status, product, product-options,
//   reorder, store-select, confirm (static Modal.confirm/error dialogs, via appModalClass)
import { Modal } from 'antd';
import { appModalClass } from './appModalClass';

export default function AppModal({ kind = 'dialog', className, ...props }) {
  return (
    <Modal {...props} className={[appModalClass(kind), className].filter(Boolean).join(' ')} />
  );
}
